export class SubTranRecordModel {
    Seq: number
    LinkNo: number
    Unit: number
    SubHist: boolean
    CheckCost: boolean
    FixUnit: string
    UnitCost: number
    BaseCharge: string
    LinkType: number
    constructor(
        Seq: number,
        LinkNo: number,
        Unit: number,
        SubHist: boolean,
        CheckCost: boolean,
        FixUnit: string,
        UnitCost: number,
        BaseCharge: string,
        LinkType: number,
    ) {
        this.Seq = Seq
        this.LinkNo = LinkNo
        this.Unit = Unit
        this.SubHist = Boolean(SubHist)
        this.CheckCost = CheckCost
        this.FixUnit = FixUnit
        this.UnitCost = UnitCost
        this.BaseCharge = BaseCharge
        this.LinkType = LinkType
    }
}